import { Box, IconButton, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { grey, alphaVar } from "../../../../../theme/muiColors";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useGlobalSnackbar } from "../../../../../context/SnackbarContext";

export const SlotField = ({ label, value }: { label: string; value: string }) => {
  const { showSnackbar } = useGlobalSnackbar();

  const handleCopy = async () => {
    if (!value?.trim()) return;
    try {
      await navigator.clipboard.writeText(value.trim());
      showSnackbar("Copied to clipboard", "info");
    } catch {
      showSnackbar("Failed to copy to clipboard", "error");
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
      <Typography variant="body1" sx={{ fontWeight: 500, color: grey[800] }}>
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: grey[100],
          p: 1,
          borderRadius: 1,
          border: `1px solid ${alphaVar(grey[200], 0.5)}`,
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 400, color: grey[700], flex: 1, minWidth: 0, fontFamily: "monospace" }}>
          {value}
        </Typography>
        <IconButton
          size="small"
          sx={{ flexShrink: 0, color: blue[300] }}
          aria-label={`Copy ${label}`}
          onClick={handleCopy}
          disabled={!value?.trim()}
        >
          <ContentCopyIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Box>
  );
};